export default __webpack_public_path__ + "static/finder-banking-customer-satisfaction-2023-8366f11bf04d9d70f1f8521fabef56ad.png";